import { claims, userType } from "../../configuration/claimSettings";
import { Constants } from "../lib/constants";
import { StringHelper, TokenHelper } from ".";

export namespace ClaimHelper {

    export const isAuthenticated = (): boolean => {
        const userClaims = TokenHelper.getClaims();
        return userClaims !== null && userClaims !== undefined;
    };
    export function hasPermission(requiredPermissions: string[] | null | undefined, userClaims? : any | null | undefined): boolean {
        if (userClaims === null || userClaims === undefined) {
            userClaims = TokenHelper.getClaims();
        }
        
        let userHasPermission = requiredPermissions === null || requiredPermissions === undefined;

        if (typeof userClaims?.permission === "string") {
            if (requiredPermissions) {
                userHasPermission = requiredPermissions?.indexOf(userClaims?.permission) >= 0;
            }
        } else {
            if (requiredPermissions) {
                userHasPermission = userClaims?.permission?.some(
                    (r: any) => requiredPermissions?.indexOf(r) >= 0
                );
            }
        }
        return userHasPermission;
    }

    export const hasRole = (requiredRoles: string[] | null | undefined): boolean => {
        const userClaims = TokenHelper.getClaims();
        let userHasRole = false;

        if (typeof userClaims?.role === "string") {
            if (requiredRoles)
                userHasRole = requiredRoles?.indexOf(userClaims?.role) >= 0;
        } else {
            if (requiredRoles)
                userHasRole = userClaims?.role?.some(
                    (r: any) => requiredRoles?.indexOf(r) >= 0
                );
        }

        return userHasRole;
    };

    export const doesNotHaveRole = (
        requiredRoles: string[] | null | undefined
    ): boolean => {
        return !hasRole(requiredRoles);
    };

    export const hasClaim = (claimType: string): string => {
        const userClaims = TokenHelper.getClaims();
        if (!userClaims) {
            return Constants.emptyString;
        }

        const claimValue = userClaims[claimType];
        if (claimValue !== null && claimValue !== undefined) {
            return claimValue;
        }

        return Constants.emptyString;
    };

    export const getClaimStringValue = (claimType: string): string => {
        const userClaims = TokenHelper.getClaims();
        if (!userClaims) {
            return Constants.emptyString;
        }

        const claimValue = userClaims[claimType];
        if (claimValue !== null && claimValue !== undefined) {
            return claimValue;
        }

        return Constants.emptyString;
    };

    export const getClaimBoolValue = (claimType: string): boolean => {
        const userClaims = TokenHelper.getClaims();
        if (!userClaims) {
            return false;
        }

        const claimValue = userClaims[claimType];
        if (claimValue !== null && claimValue !== undefined) {
            return (
                claimValue.toLowerCase() === "true" ||
                claimValue.toLowerCase() === "0" ||
                claimValue.toLowerCase() === "yes" ||
                claimValue === true
            );
        }

        return false;
    };

    export const getRole = (): string => {
        const value: string = getClaimStringValue(claims.Role);
        return StringHelper.whenNullOrEmpty(value, Constants.emptyString);
    };

    export const getRoleName = (): string => {
        const value: string = getClaimStringValue(claims.RoleName);
        return StringHelper.whenNullOrEmpty(value, Constants.emptyString);
    };

    export const getDisplayName = (): string => {
        const value: string = getClaimStringValue(claims.Name);
        return StringHelper.whenNullOrEmpty(value, Constants.emptyString);
    };

    export const getUsername = (): string => {
        const value: string = getClaimStringValue(claims.Email);
        return StringHelper.whenNullOrEmpty(value, Constants.emptyString);
    };

    export const getEmail = (): string => {
        const value: string = getClaimStringValue(claims.Email);
        return StringHelper.whenNullOrEmpty(value, Constants.emptyString);
    };

    export const getUserInitials = (): string => {
        const value: string = getClaimStringValue(claims.Initials);
        return StringHelper.whenNullOrEmpty(value, Constants.emptyString);
    };

    export const getOrganizationId = (): string => {
        const value: string = getClaimStringValue(claims.OrganizationId);
        return value;
    };

    export const getOrganizationName = (): string => {
        const value: string = getClaimStringValue(claims.OrganizationName);
        return value;
    };

    export const updateProfileDisplayName = (
        firstName: string,
        lastName: string
    ): void => {
        const userClaims = TokenHelper.getClaims();
        if (!userClaims) return;

        userClaims[claims.LastName] = lastName;
        userClaims[claims.FirstName] = firstName;
        userClaims[claims.Name] = `${firstName} ${lastName}`;
        TokenHelper.updateStorageProfile(userClaims);
    };

    export const updateProfilePhoneNumber = (phoneNumber?: string | undefined): void => {
        const userClaims = TokenHelper.getClaims();
        if (!userClaims) return;

        userClaims[claims.PhoneNumber] = phoneNumber;
        TokenHelper.updateStorageProfile(userClaims);
    }

    export const updateCommunityName = (communityName: string | undefined): void => {
        const userClaims = TokenHelper.getClaims();
        if (!userClaims) return;

        userClaims[claims.CommunityName] = communityName ?? claims.CommunityName;
        TokenHelper.updateStorageProfile(userClaims);
    }

    export const IsApplicationUser = (): boolean => {
        return isUserType(userType.SystemUser);
    };

    export const IsSystemUser = (): boolean => {
        return isUserType(userType.SystemUser);
    };

    function isUserType(userType: string): boolean {
        var value: string = getUserType();
        return value !== null && value !== undefined && value === userType;
    }

    export const getUserType = () => {
        const userType: string = getClaimStringValue(claims.UserTpe);
        return userType;
    };

    export const getUserId = (): string => getClaimStringValue(claims.UserId);

    export const getCommunityId = (): string => getClaimStringValue(claims.CommunityId);

    export const getCommunityName = (): string => getClaimStringValue(claims.CommunityName);
}